// Meta Pixel tracking helpers
// Base pixel script loaded in /public/index.html. This module wraps fbq() calls
// so components don't have to touch window globals directly.

const isReady = () => typeof window !== 'undefined' && typeof window.fbq === 'function';

export const trackPageView = () => {
  if (!isReady()) return;
  window.fbq('track', 'PageView');
};

export const trackViewContent = ({ id, name, category, price, currency = 'USD' } = {}) => {
  if (!isReady()) return;
  window.fbq('track', 'ViewContent', {
    content_ids: id ? [String(id)] : undefined,
    content_name: name,
    content_category: category,
    content_type: 'product',
    value: typeof price === 'number' ? price : undefined,
    currency,
  });
};

export const trackAddToCart = ({ id, name, category, price, quantity = 1, currency = 'USD' } = {}) => {
  if (!isReady()) return;
  const value = typeof price === 'number' ? price * quantity : undefined;
  window.fbq('track', 'AddToCart', {
    content_ids: id ? [String(id)] : undefined,
    content_name: name,
    content_category: category,
    content_type: 'product',
    contents: id ? [{ id: String(id), quantity, item_price: price }] : undefined,
    value,
    currency,
  });
};

export const trackPurchase = ({ orderId, items = [], value, currency = 'USD' } = {}) => {
  if (!isReady()) return;
  const contents = items.map((it) => ({
    id: String(it.id ?? it.productId ?? ''),
    quantity: it.quantity ?? 1,
    item_price: it.price,
  }));
  const totalValue =
    typeof value === 'number'
      ? value
      : items.reduce((sum, it) => sum + (Number(it.price) || 0) * (it.quantity || 1), 0);
  window.fbq('track', 'Purchase', {
    content_ids: items.map((it) => String(it.id ?? it.productId ?? '')).filter(Boolean),
    content_type: 'product',
    contents,
    num_items: items.reduce((sum, it) => sum + (it.quantity || 1), 0),
    value: Number(totalValue.toFixed(2)),
    currency,
    order_id: orderId ? String(orderId) : undefined,
  });
};
